// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserInquirySetting .input-row-area {
  width: 100%;
}
#AdminUserInquirySetting .input-row-area.hidden {
  display: none;
}
#AdminUserInquirySetting .input-row-area .text-switch span {
  width: 110px;
}
#AdminUserInquirySetting .input-hr.hidden {
  display: none;
}
#AdminUserInquirySetting .header-update-button {
  min-width: 160px;
}
#AdminUserInquirySetting .scroll-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  z-index: var(--z-index-local-over-5);
}
#AdminUserInquirySetting .input-label-text {
  text-align: left;
}
#AdminUserInquirySetting .input-required-mark {
  color: var(--primary-color-main);
  font-size: var(--text-size-small);
  font-weight: 600;
}
#AdminUserInquirySetting .input-label-hint {
  color: var(--font_active_sub_color, #707070);
  text-align: left;
}
#AdminUserInquirySetting .inquiry-enable-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
#AdminUserInquirySetting .inquiry-enable-switch input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
#AdminUserInquirySetting .inquiry-enable-switch .switch-track {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  background-color: var(--dark-color-light, #adb5bd);
  border-radius: 999px;
  transition: background-color 0.2s ease-in-out;
}
#AdminUserInquirySetting .inquiry-enable-switch .switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}
#AdminUserInquirySetting .inquiry-enable-switch.on .switch-track {
  background-color: var(--primary-color-main, #1F3A5F);
}
#AdminUserInquirySetting .inquiry-enable-switch.on .switch-thumb {
  transform: translateX(24px);
}
#AdminUserInquirySetting .webhook-switch-label {
  min-width: 38px;
}
#AdminUserInquirySetting .file-display-area {
  border: solid 1px var(--border-weak-color);
  padding: 32px;
}
#AdminUserInquirySetting .operate-area {
  width: 50%;
}
#AdminUserInquirySetting .operate-button {
  width: 180px;
  padding: 8px 4px;
  min-height: 28px;
  max-height: 28px;
  min-width: 72px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s color 0.3s border 0.3s;
}
#AdminUserInquirySetting .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserInquirySetting .operate-button.danger:hover {
  background-color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  color: var(--white-color-lightest);
}
#AdminUserInquirySetting .operate-button.primary {
  background-color: var(--primary-color-main);
  border: 1px solid var(--primary-color-main);
  color: var(--white-color-lightest);
}
#AdminUserInquirySetting .operate-button.primary:hover {
  background-color: var(--primary-color-dark);
  color: var(--white-color-lightest);
}
#AdminUserInquirySetting .summary-format-area {
  width: 100%;
}
#AdminUserInquirySetting .form-items-area {
  width: 100%;
}
#AdminUserInquirySetting .text-error {
  color: var(--primary-color-main);
}
#AdminUserInquirySetting .form-item-row {
  width: 100%;
  padding: 8px 4px;
  transition: opacity 0.15s, background-color 0.15s;
}
#AdminUserInquirySetting .form-item-row.dragging {
  opacity: 0.35;
}
#AdminUserInquirySetting .form-item-row.drag-over {
  border-top: 2px solid var(--primary-color-main);
  background-color: var(--primary-color-main-transparent-10, rgba(0, 123, 255, 0.06));
}
#AdminUserInquirySetting .form-item-row .form-item-col-handle {
  width: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: var(--dark-color-light, #adb5bd);
  -webkit-user-select: none;
          user-select: none;
}
#AdminUserInquirySetting .form-item-row .form-item-col-handle:active {
  cursor: grabbing;
}
#AdminUserInquirySetting .form-item-row .form-item-col-handle .drag-handle-icon {
  pointer-events: none;
}
#AdminUserInquirySetting .form-item-row .form-item-col-required {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
#AdminUserInquirySetting .form-item-row .form-item-col-name {
  flex: 1 1;
  min-width: 0;
}
#AdminUserInquirySetting .form-item-row .form-error {
  border-bottom: 1px solid var(--primary-color-main);
  height: 1.5em;
}
#AdminUserInquirySetting .form-item-row .form-item-col-label {
  flex: 1.5 1;
  min-width: 0;
}
#AdminUserInquirySetting .form-item-row .form-item-col-type {
  flex: 1 1;
  min-width: 0;
}
#AdminUserInquirySetting .form-item-row .form-item-col-placeholder {
  flex: 2.5 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#AdminUserInquirySetting .form-item-row .form-item-col-action {
  width: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
#AdminUserInquirySetting .form-item-row.editing .form-item-col-action {
  width: 80px;
}
#AdminUserInquirySetting .form-item-row-header {
  padding: 8px 4px;
  border-bottom: 1px solid var(--border-weak-color);
  margin-bottom: 4px;
}
#AdminUserInquirySetting .form-item-badge {
  width: 72px;
  padding: 4px 12px;
  text-align: center;
  font-size: var(--text-size-normal);
  font-weight: 600;
  border-radius: 4px;
  line-height: 1.4;
}
#AdminUserInquirySetting .form-item-badge.required {
  background-color: var(--plan-selected-bg);
  border: 1px solid var(--primary-color-main);
  color: var(--primary-color-main);
}
#AdminUserInquirySetting .form-item-badge.optional {
  background-color: var(--dark-color-light);
  border: 1px solid var(--dark-color-main);
  color: var(--white-color-lightest);
}
#AdminUserInquirySetting .form-item-action-button {
  width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  transition: background-color 0.2s;
}
#AdminUserInquirySetting .form-item-action-button .icon {
  padding-left: 2px;
}
#AdminUserInquirySetting .form-item-action-button.add {
  color: var(--primary-color-main);
}
#AdminUserInquirySetting .form-item-action-button.add:hover {
  background-color: var(--primary-color-main-transparent-25);
}
#AdminUserInquirySetting .form-item-action-button.remove {
  color: var(--dark-color-main);
}
#AdminUserInquirySetting .form-item-action-button.remove:hover {
  background-color: var(--dark-color-dark-transparent-10);
  color: var(--danger-color-main);
}
#AdminUserInquirySetting .form-item-action-button.save {
  color: var(--primary-color-main);
}
#AdminUserInquirySetting .form-item-action-button.save:hover {
  background-color: var(--primary-color-main-transparent-25);
}
#AdminUserInquirySetting .form-item-action-button.cancel {
  color: var(--dark-color-main);
}
#AdminUserInquirySetting .form-item-action-button.cancel:hover {
  background-color: var(--dark-color-dark-transparent-10);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserInquirySetting.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAIY;EACI,YAAA;AAFhB;AAQQ;EACI,aAAA;AANZ;AAWI;EACI,gBAAA;AATR;AAaI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EAEA,oCAAA;AAbR;AAgBI;EACI,gBAAA;AAdR;AAiBI;EACI,gCAAA;EACA,iCAAA;EACA,gBAAA;AAfR;AAkBI;EACI,4CAAA;EACA,gBAAA;AAhBR;AAoBI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAlBR;AAoBQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AAlBZ;AAqBQ;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;EACA,oBAAA;EACA,6CAAA;AAnBZ;AAsBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,sCAAA;AApBZ;AAwBY;EACI,oDAAA;AAtBhB;AAwBY;EACI,2BAAA;AAtBhB;AA2BI;EACI,eAAA;AAzBR;AA4BI;EACI,0CAAA;EACA,aAAA;AA1BR;AA6BI;EACI,UAAA;AA3BR;AA8BI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,wDAAA;AA7BR;AA+BQ;EACI,wCAAA;EACA,8BAAA;AA7BZ;AAiCY;EACI,0CAAA;EACA,0CAAA;EACA,kCAAA;AA/BhB;AAmCQ;EACI,2CAAA;EACA,2CAAA;EACA,kCAAA;AAjCZ;AAmCY;EACI,2CAAA;EACA,kCAAA;AAjChB;AAsCI;EACI,WAAA;AApCR;AAuCI;EACI,WAAA;AArCR;AAwCI;EACI,gCAAA;AAtCR;AAyCI;EACI,WAAA;EACA,gBAAA;EACA,iDAAA;AAvCR;AA0CQ;EACI,aAAA;AAxCZ;AA4CQ;EACI,+CAAA;EACA,mFAAA;AA1CZ;AA8CQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uCAAA;EACA,yBAAA;UAAA,iBAAA;AA5CZ;AA8CY;EACI,gBAAA;AA5ChB;AA+CY;EACI,oBAAA;AA7ChB;AAiDQ;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AA/CZ;AAkDQ;EACI,SAAA;EACA,YAAA;AAhDZ;AAmDQ;EACI,kDAAA;EACA,aAAA;AAjDZ;AAoDQ;EACI,WAAA;EACA,YAAA;AAlDZ;AAqDQ;EACI,SAAA;EACA,YAAA;AAnDZ;AAsDQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApDZ;AAuDQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AArDZ;AA0DY;EACI,WAAA;AAxDhB;AA6DI;EACI,gBAAA;EACA,iDAAA;EACA,kBAAA;AA3DR;AA8DI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA5DR;AA8DQ;EACI,yCAAA;EACA,2CAAA;EACA,gCAAA;AA5DZ;AA+DQ;EACI,yCAAA;EACA,wCAAA;EACA,kCAAA;AA7DZ;AAiEI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,iCAAA;AA/DR;AAiEQ;EACI,iBAAA;AA/DZ;AAkEQ;EACI,gCAAA;AAhEZ;AAkEY;EACI,0DAAA;AAhEhB;AAoEQ;EACI,6BAAA;AAlEZ;AAoEY;EACI,uDAAA;EACA,+BAAA;AAlEhB;AAsEQ;EACI,gCAAA;AApEZ;AAsEY;EACI,0DAAA;AApEhB;AAwEQ;EACI,6BAAA;AAtEZ;AAwEY;EACI,uDAAA;AAtEhB","sourcesContent":["#AdminUserInquirySetting {\n    .input-row-area {\n        width: 100%;\n\n        &.hidden {\n            display: none;\n        }\n\n        .text-switch {\n            span {\n                width: 110px;\n            }\n        }\n    }\n\n    .input-hr {\n        &.hidden {\n            display: none;\n        }\n    }\n\n    // ページヘッダーに配置する更新ボタン (初見でも気付きやすい位置に固定)\n    .header-update-button {\n        min-width: 160px;\n    }\n\n    // ページ最上部に戻すフローティングボタン (AdminUserInquiryLog と同じ見せ方)\n    .scroll-button {\n        position: fixed;\n        bottom: 16px;\n        right: 16px;\n\n        width: 64px;\n        height: 64px;\n\n        z-index: var(--z-index-local-over-5);\n    }\n\n    .input-label-text {\n        text-align: left;\n    }\n\n    .input-required-mark {\n        color: var(--primary-color-main);\n        font-size: var(--text-size-small);\n        font-weight: 600;\n    }\n\n    .input-label-hint {\n        color: var(--font_active_sub_color, #707070);\n        text-align: left;\n    }\n\n    // 有人引き継ぎ ON/OFF トグルスイッチ\n    .inquiry-enable-switch {\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n        user-select: none;\n\n        input[type=\"checkbox\"] {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n            pointer-events: none;\n        }\n\n        .switch-track {\n            position: relative;\n            display: inline-block;\n            width: 52px;\n            height: 28px;\n            background-color: var(--dark-color-light, #adb5bd);\n            border-radius: 999px;\n            transition: background-color 0.2s ease-in-out;\n        }\n\n        .switch-thumb {\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            width: 22px;\n            height: 22px;\n            background-color: #ffffff;\n            border-radius: 50%;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n            transition: transform 0.2s ease-in-out;\n        }\n\n        &.on {\n            .switch-track {\n                background-color: var(--primary-color-main, #1F3A5F);\n            }\n            .switch-thumb {\n                transform: translateX(24px);\n            }\n        }\n    }\n\n    .webhook-switch-label {\n        min-width: 38px;\n    }\n\n    .file-display-area {\n        border: solid 1px var(--border-weak-color);\n        padding: 32px;\n    }\n\n    .operate-area {\n        width: 50%;\n    }\n\n    .operate-button {\n        width: 180px;\n        padding: 8px 4px;\n        min-height: 28px;\n        max-height: 28px;\n        min-width: 72px;\n        border-radius: 14px;\n\n        border: 1px solid var(--border-weak-color);\n        background-color: var(--white-color-lightest);\n        transition: background-color 0.3s color 0.3s border 0.3s;\n\n        &:hover {\n            background-color: var(--dark-color-main);\n            color: var(--white-color-main);\n        }\n\n        &.danger {\n            &:hover {\n                background-color: var(--danger-color-main);\n                border: 1px solid var(--danger-color-main);\n                color: var(--white-color-lightest);\n            }\n        }\n\n        &.primary {\n            background-color: var(--primary-color-main);\n            border: 1px solid var(--primary-color-main);\n            color: var(--white-color-lightest);\n\n            &:hover {\n                background-color: var(--primary-color-dark);\n                color: var(--white-color-lightest);\n            }\n        }\n    }\n\n    .summary-format-area {\n        width: 100%;\n    }\n\n    .form-items-area {\n        width: 100%;\n    }\n\n    .text-error {\n        color: var(--primary-color-main);\n    }\n\n    .form-item-row {\n        width: 100%;\n        padding: 8px 4px;\n        transition: opacity 0.15s, background-color 0.15s;\n\n        // ドラッグ中の行: 半透明にして「動かしている」感を表現\n        &.dragging {\n            opacity: 0.35;\n        }\n\n        // ドロップ先の行: 上部にラインを表示して挿入位置を明示\n        &.drag-over {\n            border-top: 2px solid var(--primary-color-main);\n            background-color: var(--primary-color-main-transparent-10, rgba(0, 123, 255, 0.06));\n        }\n\n        // ドラッグハンドル列\n        .form-item-col-handle {\n            width: 24px;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: grab;\n            color: var(--dark-color-light, #adb5bd);\n            user-select: none;\n\n            &:active {\n                cursor: grabbing;\n            }\n\n            .drag-handle-icon {\n                pointer-events: none;\n            }\n        }\n\n        .form-item-col-required {\n            width: 120px;\n            flex-shrink: 0;\n            display: flex;\n            justify-content: center;\n        }\n\n        .form-item-col-name {\n            flex: 1;\n            min-width: 0;\n        }\n\n        .form-error {\n            border-bottom: 1px solid var(--primary-color-main);\n            height: 1.5em;\n        }\n\n        .form-item-col-label {\n            flex: 1.5;\n            min-width: 0;\n        }\n\n        .form-item-col-type {\n            flex: 1;\n            min-width: 0;\n        }\n\n        .form-item-col-placeholder {\n            flex: 2.5;\n            min-width: 0;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n\n        .form-item-col-action {\n            width: 40px;\n            flex-shrink: 0;\n            display: flex;\n            justify-content: center;\n        }\n\n        // 編集モード時は保存/キャンセルの2ボタンを並べるため、操作列の幅を広げる\n        &.editing {\n            .form-item-col-action {\n                width: 80px;\n            }\n        }\n    }\n\n    .form-item-row-header {\n        padding: 8px 4px;\n        border-bottom: 1px solid var(--border-weak-color);\n        margin-bottom: 4px;\n    }\n\n    .form-item-badge {\n        width: 72px;\n        padding: 4px 12px;\n        text-align: center;\n        font-size: var(--text-size-normal);\n        font-weight: 600;\n        border-radius: 4px;\n        line-height: 1.4;\n\n        &.required {\n            background-color: var(--plan-selected-bg);\n            border: 1px solid var(--primary-color-main);\n            color: var(--primary-color-main);\n        }\n\n        &.optional {\n            background-color: var(--dark-color-light);\n            border: 1px solid var(--dark-color-main);\n            color: var(--white-color-lightest);\n        }\n    }\n\n    .form-item-action-button {\n        width: 32px;\n        height: 32px;\n        min-height: 32px;\n        padding: 0;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: transparent;\n        border: none;\n        transition: background-color 0.2s;\n\n        .icon {\n            padding-left: 2px;\n        }\n\n        &.add {\n            color: var(--primary-color-main);\n\n            &:hover {\n                background-color: var(--primary-color-main-transparent-25);\n            }\n        }\n\n        &.remove {\n            color: var(--dark-color-main);\n\n            &:hover {\n                background-color: var(--dark-color-dark-transparent-10);\n                color: var(--danger-color-main);\n            }\n        }\n\n        &.save {\n            color: var(--primary-color-main);\n\n            &:hover {\n                background-color: var(--primary-color-main-transparent-25);\n            }\n        }\n\n        &.cancel {\n            color: var(--dark-color-main);\n\n            &:hover {\n                background-color: var(--dark-color-dark-transparent-10);\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
